const validationPtMessages = {
  'validate.required': 'Campo obrigatório',
  'validate.mail': 'Informe um e-mail válido',
  'validate.min.character': 'Mínimo {min} caracteres',
  'validate.number': 'Informe um número válido',
  'validate.email.already.in.use': 'O e-mail {email} já está em uso.',
};

export default validationPtMessages;
